import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/components/Layout'
import store from '@/store'

Vue.use(VueRouter)

// 路由权限映射
const routePermissions = {
  '/merchant/dashboard': 'can_view_dashboard',
  '/deposit': 'can_view_deposit',
  '/deposit/orders': 'can_view_deposit',
  '/deposit/create': 'can_create_deposit',
  '/deposit/channels': 'can_view_deposit',
  '/payout': 'can_view_payout',
  '/payout/orders': 'can_view_payout',
  '/payout/create': 'can_create_payout',
  '/payout/batch': 'can_create_payout',
  '/payout/receivers': 'can_view_payout',
  '/application': 'can_view_application',
  '/application/list': 'can_view_application',
  '/application/create': 'can_create_application',
  '/settlement': 'can_view_settlement',
  '/settlement/summary': 'can_view_settlement',
  '/settlement/records': 'can_view_settlement',
  '/account/subaccounts': 'can_view_subaccount',
  '/developer': 'can_view_developer',
  '/developer/apikeys': 'can_view_developer',
  '/developer/docs': 'can_view_developer'
}

const routes = [
  // 官网首页
  {
    path: '/',
    name: 'WebsiteHome',
    component: () => import('@/views/website/Home'),
    meta: { public: true, isWebsite: true }
  },
  // 文档中心
  {
    path: '/docs',
    name: 'DocsCenter',
    component: () => import('@/views/website/Docs'),
    meta: { public: true, isWebsite: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index'),
    hidden: true,
    meta: { public: true }
  },
  {
    path: '/cashier/:merchant_no/:slug',
    name: 'CashierPay',
    component: () => import('@/views/cashier/pay'),
    hidden: true,
    meta: { public: true }
  },
  // 商户后台
  {
    path: '/merchant',
    component: Layout,
    redirect: '/merchant/dashboard',
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      component: () => import('@/views/dashboard/index'),
      meta: { title: '控制台', icon: 'el-icon-s-home', permission: 'can_view_dashboard' }
    }]
  },
  {
    path: '/deposit',
    component: Layout,
    name: 'Deposit',
    redirect: '/deposit/orders',
    meta: { title: '入金管理', icon: 'el-icon-s-finance', permission: 'can_view_deposit' },
    children: [
      {
        path: 'orders',
        name: 'DepositOrders',
        component: () => import('@/views/deposit/orders'),
        meta: { title: '入金订单', permission: 'can_view_deposit' }
      },
      {
        path: 'create',
        name: 'DepositCreate',
        component: () => import('@/views/deposit/create'),
        meta: { title: '手动拉单', permission: 'can_create_deposit' }
      },
      {
        path: 'channels',
        name: 'DepositChannels',
        component: () => import('@/views/deposit/channels'),
        meta: { title: '入金通道', permission: 'can_view_deposit' }
      },
      {
        path: 'cashier',
        name: 'DepositCashier',
        component: () => import('@/views/deposit/cashier'),
        meta: { title: '收银台', permission: 'can_view_deposit' }
      },
      {
        path: 'cashier/:id',
        name: 'CashierDetail',
        component: () => import('@/views/deposit/cashier-detail'),
        meta: { title: '收银台详情', permission: 'can_view_deposit' },
        hidden: true
      },
      {
        path: 'orders/:order_no',
        name: 'DepositOrderDetail',
        component: () => import('@/views/deposit/order-detail'),
        meta: { title: '订单详情', permission: 'can_view_deposit' },
        hidden: true
      }
    ]
  },
  {
    path: '/payout',
    component: Layout,
    name: 'Payout',
    redirect: '/payout/orders',
    meta: { title: '下发管理', icon: 'el-icon-s-claim', permission: 'can_view_payout' },
    children: [
      {
        path: 'orders',
        name: 'PayoutOrders',
        component: () => import('@/views/payout/orders'),
        meta: { title: '下发订单', permission: 'can_view_payout' }
      },
      {
        path: 'create',
        name: 'PayoutCreate',
        component: () => import('@/views/payout/create'),
        meta: { title: '发起下发', permission: 'can_create_payout' }
      },
      {
        path: 'batch',
        name: 'PayoutBatch',
        component: () => import('@/views/payout/batch'),
        meta: { title: '批量下发', permission: 'can_create_payout' }
      },
      {
        path: 'receivers',
        name: 'PayoutReceivers',
        component: () => import('@/views/payout/receivers'),
        meta: { title: '收款人管理', permission: 'can_view_payout' }
      }
    ]
  },
  {
    path: '/application',
    component: Layout,
    name: 'Application',
    redirect: '/application/list',
    meta: { title: '进件管理', icon: 'el-icon-document', permission: 'can_view_application' },
    children: [
      {
        path: 'list',
        name: 'ApplicationList',
        component: () => import('@/views/application/list'),
        meta: { title: '进件列表', permission: 'can_view_application' }
      },
      {
        path: 'create',
        name: 'ApplicationCreate',
        component: () => import('@/views/application/create'),
        meta: { title: '新建进件', permission: 'can_create_application' }
      }
    ]
  },
  {
    path: '/settlement',
    component: Layout,
    name: 'Settlement',
    redirect: '/settlement/summary',
    meta: { title: '结算管理', icon: 'el-icon-s-data', permission: 'can_view_settlement' },
    children: [
      {
        path: 'summary',
        name: 'SettlementSummary',
        component: () => import('@/views/settlement/summary'),
        meta: { title: '结算汇总', permission: 'can_view_settlement' }
      },
      {
        path: 'records',
        name: 'SettlementRecords',
        component: () => import('@/views/settlement/records'),
        meta: { title: '结算记录', permission: 'can_view_settlement' }
      }
    ]
  },
  {
    path: '/account',
    component: Layout,
    name: 'Account',
    redirect: '/account/index',
    meta: { title: '账户管理', icon: 'el-icon-user' },
    children: [
      {
        path: 'index',
        name: 'AccountIndex',
        component: () => import('@/views/account/index'),
        meta: { title: '账户信息' }
      },
      {
        path: 'subaccounts',
        name: 'SubAccounts',
        component: () => import('@/views/account/subaccounts'),
        meta: { title: '子账号管理', permission: 'can_view_subaccount' }
      }
    ]
  },
  {
    path: '/message',
    component: Layout,
    name: 'Message',
    component: () => import('@/views/message/index'),
    meta: { title: '消息中心', icon: 'el-icon-bell' },
    hidden: true
  },
  {
    path: '/announcements',
    component: Layout,
    name: 'Announcements',
    component: () => import('@/views/announcement/index'),
    meta: { title: '平台公告' },
    hidden: true
  },
  {
    path: '/todos',
    component: Layout,
    name: 'Todos',
    component: () => import('@/views/todo/index'),
    meta: { title: '待办事项' },
    hidden: true
  },
  {
    path: '/developer',
    component: Layout,
    name: 'Developer',
    redirect: '/developer/apikeys',
    meta: { title: '开发者中心', icon: 'el-icon-s-tools', permission: 'can_view_developer' },
    children: [
      {
        path: 'apikeys',
        name: 'DeveloperApiKeys',
        component: () => import('@/views/developer/apikeys'),
        meta: { title: 'API密钥' }
      },
      {
        path: 'callback',
        name: 'DeveloperCallback',
        component: () => import('@/views/developer/callback'),
        meta: { title: '回调配置' }
      },
      {
        path: 'docs',
        name: 'DeveloperDocs',
        component: () => import('@/views/developer/docs'),
        meta: { title: 'API文档' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 冻结商户允许访问的路径
const FROZEN_ALLOWED_PATHS = ['/merchant/dashboard']

// 路由守卫 - 权限检查
router.beforeEach((to, from, next) => {
  const token = store.getters.token
  const merchant = store.getters.merchant
  const permissions = store.getters.permissions
  const isFrozen = store.state.user.isFrozen || merchant?.status === 2
  
  // 公开页面无需登录（官网、文档中心等）
  if (to.meta.public) {
    next()
    return
  }
  
  // 未登录且访问非登录页，跳转到登录
  if (!token && to.path !== '/login') {
    next('/login')
    return
  }
  
  // 已登录且访问登录页，跳转到商户后台首页
  if (token && to.path === '/login') {
    next('/merchant/dashboard')
    return
  }
  
  // 冻结商户限制：只能访问控制台
  if (token && isFrozen) {
    const isAllowed = FROZEN_ALLOWED_PATHS.some(path => to.path === path || to.path.startsWith(path + '/'))
    if (!isAllowed) {
      // 显示冻结提示并跳回控制台
      Vue.prototype.$message.error('您的账户已被冻结，请联系泛海支付管理员')
      if (to.path !== '/merchant/dashboard') {
        next('/merchant/dashboard')
        return
      }
    }
  }
  
  // 检查权限（子账号需要检查）
  if (token && merchant.user_type === 'sub_account') {
    const requiredPermission = to.meta.permission || routePermissions[to.path]
    if (requiredPermission) {
      const permValue = permissions[requiredPermission]
      const hasPermission = permValue === true || permValue === 1 || permValue === '1'
      if (!hasPermission) {
        // 避免循环跳转
        if (to.path !== '/merchant/dashboard' && from.path !== '/merchant/dashboard') {
          Vue.prototype.$message.error('您没有权限访问此页面')
          next('/merchant/dashboard')
        } else if (to.path === '/merchant/dashboard' && !permissions['can_view_dashboard']) {
          // 如果连控制台都没有权限，跳转到账户信息页（所有人都能访问）
          next('/account/index')
        } else {
          next()
        }
        return
      }
    }
  }
  
  next()
})

export default router
